<template>
  <div class="profile-menu-wrapper" data-app>
    <BbMenu
      v-model="showMenu"
      class="profile-menu"
      display-items="6"
      max-width="240px"
      min-width="240px"
      min-height="160px"
      nudge-bottom="8"
      size="medium"
      is-offset-y
      alignment="bottom-left"
    >
      <template #menuActivator>
        <BbBtn :class="['open-profile-menu-button', { active: showMenu }]" :width="40" :height="40">
          <BbAvatar class="avatar-icon" color="#a56bae" :full-name="fullName" />
        </BbBtn>
      </template>

      <BbMenuItem
        v-if="userData?.permissions"
        v-has-access:hide="{ resource: myFilesItem.resource, resource_action: myFilesItem.action }"
        size="medium"
        @click="handleMenuItemClick(myFilesItem.name)"
      >
        <TextBody :i18n-key="myFilesItem.label" />
      </BbMenuItem>

      <BbMenuItem
        v-for="(item, index) in items"
        :key="`profile-item-${index}`"
        :class="{ logout: item.name === 'logout' }"
        size="medium"
        @click="handleMenuItemClick(item.name)"
      >
        <TextBody :i18n-key="item.label" />
      </BbMenuItem>
    </BbMenu>
  </div>
</template>

<script>
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import TextBody from '~/components/common/TextBody';
import useModals from '~/composables/useModals';
import { Logout } from '~/constants/actions';
import { Routes } from '~/constants/routes';

const myFilesItem = {
  name: 'files',
  label: 'account.myFiles',
};

const PROFILE_MENU = [
  {
    name: 'glossaries',
    label: 'account.editGlossaries',
  },
  {
    name: 'creations',
    label: 'account.myCreations',
  },
  {
    name: 'logout',
    label: 'account.logOut',
  },
];

export default {
  name: 'ProfileMenu',
  components: { TextBody },
  props: {
    userData: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const store = useStore();
    const { setShowFiles, setGlossaryModal } = useModals();
    const router = useRouter();

    const showMenu = ref(false);

    const fullName = computed(() => {
      const { firstName = '', lastName = '', email = '' } = props?.userData || {};

      return firstName || lastName ? [firstName, lastName].join(' ') : email;
    });

    const items = PROFILE_MENU;

    const handleMenuItemClick = async (eventName) => {
      if (eventName === 'logout') {
        await store.dispatch(`authStore/${Logout}`);
      } else if (eventName === 'glossaries') {
        setGlossaryModal(true);
      } else if (eventName === 'files') {
        setShowFiles(true);
      } else if (eventName === 'creations') {
        router.push(Routes.MyCreations);
      }
    };

    return {
      fullName,
      handleMenuItemClick,
      items,
      myFilesItem,
      showMenu,
    };
  },
};
</script>

<style scoped lang="scss">
.profile-menu-wrapper {
  .avatar-icon {
    @include bb-medium-text-styles('lg');
    color: $bb-neutral-0;

    :deep(.bb-avatar__image) {
      margin-right: 0;
    }
  }

  .activator-container .open-profile-menu-button {
    min-width: 40px;
  }

  .logout {
    color: $bb-primary-1 !important;
  }
}
</style>
